import { Link } from 'react-router-dom';
import { MoveUpRight } from 'lucide-react';

export function Logo({ to = '/' }: { to?: string }) {
  return <Link className="logo" to={to} aria-label="ETAtoOffer — Know your ETA. Earn your offer."><span className="logo-mark"><MoveUpRight /></span><span className="logo-word"><strong>ETA</strong><em>toOffer</em></span></Link>;
}
